import anonymousStorage from 'usage-tracker-core/containers/anonymousStorage';
import { getAndRefreshHamplitudeProperties } from 'usage-tracker-core/metaProperties';
export const LABORATORY_IDENTIFIER_META_TAG = 'meta[name="laboratory-identifier-other"]';
const getAnonymousLaboratoryIdentifier = () => {
  // Retrieves the Laboratory Identifier from the Laboratory Meta Tag
  // NOTE: It retrieves the Anonymous Laboratory Identifier
  const metaElement = document.querySelector(LABORATORY_IDENTIFIER_META_TAG);
  return (metaElement === null || metaElement === void 0 ? void 0 : metaElement.getAttribute('content')) || undefined;
};
export const getAnonymousDeviceId = () => {
  // The Laboratory Identifier is only available if the Cloudflare Worker is present
  const laboratoryIdentifier = getAnonymousLaboratoryIdentifier();

  // We use this method to set the usage-tracker deviceId to the Laboratory Identifier
  // if the identifier is present, otherwise it will fallback to a generated UUID
  // which happens inside the `getAndRefreshHamplitudeProperties` method
  const {
    device_id
  } = getAndRefreshHamplitudeProperties(anonymousStorage.getItem, anonymousStorage.setItem, {
    currentTime: Date.now(),
    deviceId: laboratoryIdentifier
  });
  return device_id;
};

/**
 * Returns the Google Analytics tracking classname as-is.
 * This is an identity function used to standardize GA classname handling across the codebase.
 *
 * @param gaTrackingClassname - The GA tracking classname string
 * @returns The same classname string
 */
export const getGAClassName = gaTrackingClassname => {
  return gaTrackingClassname;
};